import { useQueryClient } from '@tanstack/react-query';

import { ResultOf, gql } from '@/utilities/gql';

import { PORTFOLIOS_QUERY_KEY } from '../usePortfolio';
import { AGGREGATE_PORTFOLIO_QUERY_KEY } from '../useAggregatePortfolio';

import { makeGqlMutation } from '@/utilities/gqlQuery';

const MUTATION = gql(`
  mutation createTransactionPortfolio($name: String) {
    createTransactionPortfolio(name: $name) {
      id
    }
  }
`);

const mutation = makeGqlMutation(MUTATION);

interface Props {
  onSuccess?: (data: ResultOf<typeof MUTATION>) => void;
}

export function useCreateTransactionPortfolio({ onSuccess }: Props = {}) {
  const queryClient = useQueryClient();

  return mutation({
    onSuccess,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: PORTFOLIOS_QUERY_KEY });
      queryClient.invalidateQueries({
        queryKey: AGGREGATE_PORTFOLIO_QUERY_KEY,
      });
    },
  });
}
